<div class="form-group">
    <label class="col-xs-9 control-label">
        {{ "background_settings_image" | translate }}
    </label>
    <div class="col-xs-3 text-right" [tooltip]="disabled() ? disabledBackgroundImage : ''">
        <sp-switch [disabled]="disabled()" [active]="showSettings()" (toggleActiveEvent)="toggleShowSettings($event)" />
    </div>
</div>

<ng-template #disabledBackgroundImage>
    {{ "background_image_tooltip" | translate }}
</ng-template>

@if (showSettings()) {
    <div class="form-group">
        <div class="col-xs-12">
            <sp-file-manager
                [fmSourceType]="fmSourceType.LANDING"
                [file]="image()"
                [displayOnly]="[directoryItemCategory.Image]"
                (setFileEvent)="setImage($event)"
                (replaceFileEvent)="replaceImage($event)"
            >
                @if (!image()) {
                    <sp-defautl-upload-button stockImagesDropdown (unsplashRequested)="unsplashClickRequested.emit()" />
                }
                <ng-template
                    #previewTemplate
                    let-file="file"
                    let-replaceFileFn="replaceFileFn"
                    let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                >
                    <sp-files-select
                        #ref
                        toggless
                        (unsplashClick)="unsplashClickRequested.emit()"
                        (myPhotosClick)="replaceFileFn()"
                    >
                        <sp-control-handle
                            [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                            [controlHandleMainText]="file.name"
                            (removeActionEvent)="removeImage()"
                            (replaceActionEvent)="ref.dp.toggle()"
                            (imageEditEvent)="showEditImageModalEvent.emit()"
                            [isDisableEditor]="!isImageOwner()"
                        />
                    </sp-files-select>
                </ng-template>
            </sp-file-manager>
            <div class="help-block mb-0 small text-muted">{{ "background_size_noty" | translate }}</div>
        </div>
    </div>
}

@if (showSettings() && image() && !isImageOwner()) {
    <div class="form-group">
        <div class="alert alert-sm alert-info-mutted">
            <span>{{ "disabled_image_editor_tooltip" | translate }}</span>
        </div>
    </div>
}
@if (showSettings() && image() && isImageOwner()) {
    @if (repeat() !== repeatOptions.repeat) {
        <div class="form-group mb-15 form-horizontal">
            <label class="col-xs-5 control-label">
                {{ "background_settings_size" | translate }}
            </label>
            <div class="col-xs-7">
                <select class="form-control" (change)="setSize($event)">
                    @for (option of backgroundSizeOptions; track option) {
                        <option [value]="option.value" [selected]="option.value === size()">
                            {{ option.label | translate }}
                        </option>
                    }
                </select>
            </div>
        </div>
    }
    @if (
        repeat() !== repeatOptions.repeat &&
        size() !== sizeOptions.cover &&
        scrollEffect().value !== scrollEffectType.PARALLAX
    ) {
        <div class="form-group row mb-15 form-horizontal">
            <label class="col-xs-5 control-label">
                {{ "background_settings_position" | translate }}
            </label>
            <div class="col-xs-7">
                <select class="form-control" (change)="setPosition($event)">
                    @for (option of backgroundPositionOptions; track option) {
                        <option [value]="option.value" [selected]="option.value === position()">
                            {{ option.label | translate }}
                        </option>
                    }
                </select>
            </div>
        </div>
    }
    @if (size() !== sizeOptions.cover && scrollEffect().value !== scrollEffectType.PARALLAX) {
        <div class="form-group row mb-0 form-horizontal">
            <label class="col-xs-5 control-label">
                {{ "background_settings_repeat" | translate }}
            </label>
            <div class="col-xs-7">
                <select class="form-control" (change)="setRepeat($event)">
                    @for (option of backgroundRepeatOptions; track option) {
                        <option [value]="option.value" [selected]="option.value === repeat()">
                            {{ option.label | translate }}
                        </option>
                    }
                </select>
            </div>
        </div>
    }
    @if (size() === sizeOptions.cover) {
        <div class="form-group row mb-0 form-horizontal">
            <label class="col-xs-9">
                {{ "control_choose_focus_point" | translate }}
            </label>
            <div class="col-xs-12">
                <div class="bg-position-wrapper" (click)="$event.preventDefault()">
                    <div class="bg-container" (click)="setFocusPoint($event)">
                        <img #imgTest [src]="imageSrc()" alt="" />
                        <span
                            class="focus-point"
                            [style.left]="focusPointPosition().left"
                            [style.top]="focusPointPosition().top"
                        ></span>
                    </div>
                </div>
            </div>
        </div>
    }
    <div class="form-group mb-0">
        <div class="col-xs-12">
            <hr class="panel-options-divider mb-15" />
        </div>
    </div>
    @if (allowImageEffects()) {
        <div [class.mb-10]="filter().isEnabled" [class.mb-20]="!filter().isEnabled" class="form-group">
            <label class="col-xs-9 control-label">
                {{ "control_filter_overlay" | translate }}
            </label>
            <div class="col-xs-3 text-right">
                <sp-switch [active]="filter().isEnabled" (toggleActiveEvent)="toggleFilter($event)" />
            </div>
        </div>
        @if (filter().isEnabled) {
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <div class="appearance-wrapper">
                        @for (el of filterOverlayTypes; track el) {
                            <div
                                class="appearance-block"
                                [class.active]="filter().value === el.type"
                                (click)="setFilter(el.type)"
                            >
                                <img [src]="imageSrc()" alt="" [style.filter]="el.type" />
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (filter().isEnabled) {
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider mb-15" />
                </div>
            </div>
        }
        <div [class.mb-10]="overlay().isEnabled" [class.mb-20]="!overlay().isEnabled" class="form-group">
            <label class="col-xs-9 control-label">
                {{ "control_color_overflow" | translate }}
            </label>
            <div class="col-xs-3 text-right">
                <sp-switch [active]="overlay().isEnabled" (toggleActiveEvent)="toggleOverlay($event)" />
            </div>
        </div>
        @if (overlay().isEnabled) {
            <div class="form-group row mb-0 form-horizontal">
                <div class="col-xs-10">
                    <label class="mb-0"
                        >{{ "control_saturation" | translate }} {{ overlay().opacity * 100 | number: "1.0-0" }}%</label
                    >
                    <sp-slider
                        [options]="sliderOptions"
                        [value]="overlay().opacity"
                        (valueChangeEvent)="setOverlayOpacity($event)"
                    />
                </div>
                <div class="col-xs-2">
                    <sp-color-picker
                        [hideGradient]="true"
                        [colorsPreset]="themeColors()"
                        [color]="overlay().color"
                        (colorChangeEvent)="setOverlayColor($event)"
                    />
                </div>
            </div>
        }
        @if (overlay().isEnabled) {
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider mb-15" />
                </div>
            </div>
        }
        @if (isParallaxActive()) {
            <div [class.mb-10]="scrollEffect().isEnabled" [class.mb-20]="!scrollEffect().isEnabled" class="form-group">
                <label class="col-xs-9 control-label">
                    {{ "control_scroll_effect" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="scrollEffect().isEnabled" (toggleActiveEvent)="toggleScrollEffect($event)" />
                </div>
            </div>
        }
        @if (scrollEffect().isEnabled && isParallaxActive()) {
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <div class="btn-group btn-group-justified btn-group-with-tooltip" data-toggle="buttons">
                        <button
                            class="btn btn-grey"
                            [class.active]="scrollEffect().value === scrollEffectType.FIXED"
                            (click)="setScrollEffect(scrollEffectType.FIXED)"
                        >
                            {{ "control_scroll_fixed" | translate }}
                        </button>
                        <button
                            class="btn btn-grey"
                            [class.active]="scrollEffect().value === scrollEffectType.PARALLAX"
                            (click)="setScrollEffect(scrollEffectType.PARALLAX)"
                        >
                            {{ "control_scroll_parallax" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        }
    }
}
